import React, { useEffect, useState } from 'react';
import '../AutoComplete.css'
import axios from 'axios';
import Swal from "sweetalert2";
import AutoSlider from './AutoSlider';
import ModalComponent from './ModalComponent';
import YouTubePlayer from './YouTubePlayer';

const SearchData = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const productImgUrl = process.env.REACT_APP_Product_Images_URL;
    const brochureUrl = process.env.REACT_APP_Product_URL;
    const [productItemDetailData, setProductItemDetailData] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setshowSuggestions] = useState(false);
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [dynamicData, setProductDynamicData] = React.useState(false);
    const [saveproductItemDetailID, setProductItemDetailID] = React.useState('');
    const [saveProductName, setProductName] = React.useState('');

    const [placeholderText, setPlaceholderText] = useState('');
    const initialPlaceholder = "Seearch Product...";

    const [formData, setFormData] = useState({
        searchData: {
            textValue: "",
            required: true
        }
    });

    // Dummy data for suggestions
    // const dummySuggestions = ['Apple', 'Banana', 'Cherry', 'Date', 'Grape'];

    useEffect(() => {
        let currentIndex = 0;

        const typingInterval = setInterval(() => {
            setPlaceholderText((prevText) =>
                currentIndex < initialPlaceholder.length
                    ? prevText + initialPlaceholder[currentIndex]
                    : prevText
            );

            currentIndex += 1;

            if (currentIndex === initialPlaceholder.length + 1) {
                clearInterval(typingInterval);
            }
        }, 100); // Adjust the typing speed by changing the interval duration

        // Cleanup the interval on component unmount
        return () => clearInterval(typingInterval);
    }, []);

    const handleInputChange = async (e) => {
        const value = e.target.value;
        setInputValue(value);

        let filterSuggestion = [];

        const response = await axios.post(`${baseUrl}Search/GetAutoSuggestion`, { SearchData: value });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                // setfilterSuggestion(response.data.data.map(item => item["SearchResult"]));
                filterSuggestion = response.data.data.map(item => item["SearchResult"]);
            }
        }

        // Filter suggestions based on input value
        // const filteredSuggestions = filterSuggestion.filter(suggestion =>
        //     suggestion.toLowerCase().includes(value.toLowerCase())
        // );
        // console.log("hdajdhadahdkad", filterSuggestion);

        setSuggestions(filterSuggestion);
        setActiveSuggestion(0);
        setshowSuggestions(true);

        setFormData({
            ...formData,
            [e.target.name]: {
                ...formData[e.target.name],
                textValue: e.target.value,
            },
        });
    };

    const handleSuggestionClick = (suggestion) => {
        setInputValue(suggestion);
        setActiveSuggestion(0);
        setshowSuggestions(false);
        setSuggestions([]);
    };

    const onkeyPress = (e) => {
        if (e.keyCode === 13) {
            setActiveSuggestion(0);
            setshowSuggestions(true);
            setInputValue(suggestions[activeSuggestion])
        } else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }
            setActiveSuggestion(-1);
        }
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === suggestions.length) {
                return;
            }
            setActiveSuggestion(activeSuggestion + 1)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        let validForm = true;
        for (let key in formData) {
            if (formData[key].required) {
                if (!formData[key].textValue) {
                    validForm = false;
                }

                if (!validForm) {
                    return;
                }
            }
        }
        try {
            const res = await fetch(
                `${baseUrl}Search/GetSearchData`,
                {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        SearchData: formData.searchData.textValue
                    }),
                }
            );
            const result = await res.json();
            console.log("result", result);
            if (result.status === 1) {
                setProductItemDetailData(result.data);
            } else {
                setProductItemDetailData([])
                Swal.fire({
                    title: "Result not found",
                    icon: "success",
                    timer: 1500,
                });
            }
            // setFormData({
            //     searchData: {
            //         textValue: "",
            //         required: true
            //     }
            // });
            setIsSubmit(false);
            // setInputValue('');
        } catch (err) {
            console.log(err, "err");
        }
    }

    const openModal = (data, ProductItemDetailID, ProductName) => {
        setProductDynamicData(data)
        setProductItemDetailID(ProductItemDetailID)
        setProductName(ProductName)
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (
        <>
            <div className="page-header title-area">
                <div className="header-title headerbgimg">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="page-title">
                                    Find Products
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="row">
                            <form id='frmsuggestion' method="post" onSubmit={handleSubmit}>
                                <div className="col-md-offset-1 col-md-8 col-sm-12 col-xs-12">
                                    <nav className="breadcrumb">
                                        <input
                                            type="text"
                                            name='searchData'
                                            onChange={handleInputChange}
                                            onKeyDown={onkeyPress}
                                            value={inputValue}
                                            className='form-control typing'
                                            autoComplete='off'
                                            placeholder={placeholderText}
                                        />
                                        {isSubmit && !formData.searchData.textValue && (
                                            <span style={{ color: "red" }}>
                                                Please Enter details for Search
                                            </span>
                                        )}
                                        {suggestions.length > 0 ? (
                                            <ul className="suggestions">
                                                {suggestions.map((suggestion, index) => {
                                                    let className;
                                                    if (index === activeSuggestion) {
                                                        className = "suggestion-active";
                                                    }
                                                    return (
                                                        <li className={className} key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                                            {suggestion}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        ) :
                                            (
                                                <div className="no-suggestions">
                                                    <em>No suggestions available.</em>
                                                </div>
                                            )
                                        }
                                    </nav>
                                </div>
                                <div className="col-md-2 col-sm-12 col-xs-12">
                                    <input type="submit" className='fp-btn' text='Search' value='Search' />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="site-content">
                <div className="container">
                    <div className="row">
                        <div id="primary" className="content-area col-md-12 col-sm-12 col-xs-12  woocommerce">
                            <div className="product">
                                {/* {console.log("ashajshashsjh", productItemDetailData)} */}
                                {productItemDetailData &&
                                    productItemDetailData.map((item, index) => (
                                        <div key={index} className="product-details clearfix productlist">
                                            <div className="images-product">
                                                <div className="product-gallery">
                                                    <div className="flex-viewport">
                                                        <figure>
                                                            <div className="large_image">
                                                                {item.ImageDetail != null ?
                                                                    <AutoSlider images={item.ImageDetail} interval={5000} />
                                                                    : <img src={productImgUrl + 'Product.png'} />
                                                                }
                                                                <a></a>
                                                            </div>
                                                            {item.YoutubeLink &&
                                                                <div className="large_image">
                                                                    <YouTubePlayer youtubeLink={item.YoutubeLink} />
                                                                </div>
                                                            }
                                                        </figure>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="summary entry-summary pad10">
                                                <div className='scrollable-content p-0'>
                                                    <h1 className="product_title entry-title pb-0">{item.ProductName}</h1>
                                                    <div className='row'>
                                                        <div className='col-md-6 text-left'>
                                                            {item.Price &&
                                                                <p className="price">
                                                                    <span className="amount"><span>Rs. </span>{item.Price}</span>
                                                                </p>
                                                            }
                                                        </div>
                                                        {item.Brochure &&
                                                            <div className='col-md-6'>
                                                                <div className='service-sidebar'>
                                                                    <div className='download'>
                                                                        <div className="item-download p-3">
                                                                            <span className="file pdf">PDF</span>
                                                                            <a href={brochureUrl + item.Brochure} target="_blank">Brouchure.pdf<i className="fa fa-download" aria-hidden="true"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {/* {item.YoutubeLink &&
                                                            <div className='col-md-6'>
                                                                <div className='service-sidebar'>
                                                                    <div className='download'>
                                                                        <div className="item-download p-3">
                                                                            <span className="file pdf">Video</span>
                                                                            <a href={item.YoutubeLink} target="_blank">Youtube<i className="fa fa-youtube" aria-hidden="true"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        } */}
                                                    </div>

                                                    {item.ProductItemSubDetail &&
                                                        <>
                                                            <div className="fp-section-title clearfix">
                                                                <h2 className='font15'>Details</h2>
                                                            </div>
                                                            <div className="table-responsive">
                                                                <table className="table table-2">
                                                                    <tbody>
                                                                        {item.ProductItemSubDetail.map((items, index) => (
                                                                            <tr key={index}>
                                                                                <td>{items.Title}</td>
                                                                                <td>{items.Description}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </>
                                                    }

                                                    {item.Description &&
                                                        <div className='text-justify' dangerouslySetInnerHTML={{ __html: item.Description }}>
                                                        </div>
                                                    }
                                                </div>
                                                {/* <div className='mt-10'>
                                                    <button id='btnQuote' className='fp-btn btn' onClick={() => openModal(item.ProductOtherTypeDetail, item.ProductItemDetailID, item.ProductName)}>Get A Quote</button>

                                                </div> */}

                                                <div className='row'>
                                                    <div className='mt-10 col-md-5'>
                                                        <a href={"tel:+919825154496"}>
                                                            <button id='btnQuote' className='fp-btn btn' style={{ width: '100%' }}>Call Now</button>
                                                        </a>
                                                    </div>

                                                    <div className='mt-10 col-md-4'>
                                                        <button id='btnQuote' className='fp-btn btn' onClick={() => openModal(item.ProductOtherTypeDetail, item.ProductItemDetailID, item.ProductName)} style={{ width: '100%' }}>Get A Quote</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        <ModalComponent isOpen={modalIsOpen} onRequestClose={closeModal} data={dynamicData} ProductItemDetailID={saveproductItemDetailID} ProductName={saveProductName} onSubmit={closeModal} />

                    </div>
                </div>
            </div>
        </>
    )
}
export default SearchData